export const defaultPriceByDate = {
  beforeSeason: "1.4. - 30.6.",
  season: "1.7. - 31.8.",
  afterSeason: "1.9. - 30.11.",
};

export const defaultPriceList = {
  outSeason: {
    text: "cena chaty / týden (mimo sezónu)",
    price: "18.000,- Kč",
  },
  season: {
    text: "cena chaty / týden (sezóna)",
    price: "25.000,- Kč",
  },
};

export const defaultInfoText = {
  lineOne:
    "Minimální cena pronájmu celé chaty na jednu noc je 4000,- Kč do 7 osob.",
  lineTwo: "Od 8 osob je cena za osobu 600,- Kč za 1 noc.",
  footerLine: "Chatu pronajímáme od dvou nocí.",
};

export const defaultPriceInfoText = {
    lineOne: 'Pokud máte o pronájem chaty zájem, je potřeba do 5 dnů zaplatit rezervační poplatek, což je 1/2 z celkové ceny. Po té co bude rezervační poplatek uhrazen, Vám bude pobyt závazně rezervován.',
    lineTwo: 'Informace na tel: 603 576 670 ',
    lineThree: 'email:  v.macanova@seznam.cz',
    lineFour: 'Mimo sezónu pronajímáme chatu i na víkend.',
    lineFive: 'Minimální  cena za noc / chata činí 4000,- Kč. Chatu pronajímáme od dvou nocí. V období letních prázdnin pronajímáme chatu pouze turnusově, tj od soboty do soboty, za cenu 25.000,- kč na týden, max 10 osob.',
    strongLine: 'Cena zahrnuje: ubytovácí poplatky, pronájem chaty s příslušenstvím, ložní prádlo, ručníky.',
  }

export const defaultStornoText = {
    header: 'Storno podmínky vztahující se na zrušení rezervace ubytování ze strany hosta:',
    lineOne: '1.Ubytovatel se zavazuje neúčtovat storno poplatky v případě zrušení rezervace do 21 dnů před ohlášeným příjezdem.',
    lineTwo: '2.Při zrušení rezervace 20 - 14 dní před příjezdem bude jako storno poplatek účtováno 25% z celkové ceny pobytu.',
    lineThree: '3.Při zrušení rezervace 13 - 7 dní před příjezdem bude jako storno poplatek účtováno 35% z celkové ceny pobytu.',
    lineFour: '4.Při zrušení rezervace 6 - 3 dny před příjezdem bude jako storno poplatek účtováno 50% z celkové ceny pobytu.',
    lineFive: '5.Při zrušení rezervace 3-1 den před příjezdem nebo v den příjezdu bude jako storno poplatek účtováno 100% z celkové ceny pobytu.',
    lineSix: '6.Při zkrácení délky pobytu platí stejné stornolhůty jako při zrušení pobytu.',
    lineSeven: '7.Stornopoplatek je smluvní pokutou.',
  }
